// @ts-nocheck
import PropTypes from 'prop-types';
import { memo } from 'react';
import { FormSelect, FormCheckbox, FormDateTime, FormTextField } from './form';

const CustomField = memo(
  ({
    inputType, // text, select, date, dateTime, time, checkbox
    options, //  if inputType='select' ... list the options
    disabledOptionValues, // if inputType='select' ... any options that should be disabled/hidden when not selected
    label, // the text that appears above the field
    timezone: timezoneProp, // only if date, dateTime, time ... sets it to timezone, optional
    width, // default 100%, u can define any unit
    maxWidth, // default 100%, u can define any unit
    customStyle,
    regex: regexProp,
    readOnly, // alternative to disabled, but doesn't gray it out
    step: stepProp, // inputType='text' && type='number' , defines decimals if u want decimals set step='any', optional
    mask: maskProp, // inputType='text', u can either specify a preset (phone). can customize
    maskChar, // default _ , placeholder if nothing is there
    secured: securedProp, // blured it will be dots, when its focused u can read it
    optionLabel, // inputType='select' && options of object, specify the object key that u want label to be
    optionValue, // inputType='select' && options of object, specify the object key that u want value to be
    chipLabel, // inputType='select' && multiple options of object, specify the chip label key
    cbChange, // callback on change, this is only partially, selects, but can be implemented on other fields if we need it
    onChange: onChangeProp, // this is called on every change (used for textfield)
    endProp, // what u want at the end inside of the field
    lookup, // instead of options or mode, u define lookup to get a specific lookup table
    mode, // instead of options or lookup, specify a mode (yeno, timezone)
    variant: variantProp, // outlined, standard, etc. (MUI) rarely changed. default outlined
    name: nameProp, // name of the input, also used for control change and formik value getting and setting
    squared, // removed the border radius
    type: typeProp, // u can specify number or a html type
    required: requiredProp, // adds * but still needs to be added to the formik validation as well
    min: minProp, // type='number' min value
    max: maxProp, // type='number' max value
    multiline: multilineProp, // allows for more then one line primary use is for textareas
    rows: rowsProp, // specifys how many rows primary use for textareas
    rowsMax: rowsMaxProp, // limits the rows for a textarea
    disabled: disabledProp, // boolean value for disable
    labelPlacement: labelPlacementProp, // position of label in Checkbox can be | start | bottom | end | top
    value: valueProp, // the inital value you want it to start with
    error: errorProp, // a string with an error message
    table: tableProp, // show or hide the border
    futureDisabled,
    pastDisabled,
    helperText,
    noPadding,
    zeroPadding,
    groupBy,
    noFlash,
    newLoader,
    minDate: minDateProp,
    maxDate: maxDateProp,
    beforeDeath: beforeDeathProp, // checks if value is before date/time of death
    afterDeath: afterDeathProp, // checks if value is 72 hrs after date/time of death
    maxCustomDate: maxCustomDateProp, // checks if value is before data/time and adjusts message based on typeName passed
    minCustomDate: minCustomDateProp, // checks if value is after data/time and adjusts message based on typeName passed
    afterCustomDatetime: afterCustomDatetimeProp, // Allows us to specify to specify how much time, type of time and message to display
    beforeCustomDatetime: beforeCustomDatetimeProp, // Allows us to specify to specify how much time, type of time and message to display
    noColorChange, // boolean if u want it to change color if no longer inital value
    lookupWhere, // find lookups specified by set of attributes
    noOptionsDisabled, // disable if no options are available
    roles: rolesProp, // prop for specifying role
    organizations: organizationsProp, // prop for specifying role
    mapValues, // prop for specifying role
    order: orderProp, // prop for giving an order to the select
    writeOnly, // always be in write mode even if it in in view mode
    viewOnly, // always be in view mode even if it in in write mode
    placeholder: placeholderProp, // a placeholder
    maxLines: maxLinesProp,
    size: sizeProp,
    multiple: multipleProp,
    noMargin,
    defaultLocal,
    outcomes: outcomesProp,
    outcomeDetails: outcomeDetailsProp,
    removeIcons,
    partners: partnersProp,
    setTimezone,
    showTimezone,
    noInitialValue, // passed to conditionally rendered fields or fields that populate based on other fields to properly clear out value on cancel
    validator: validatorProp,
    disablePortal,
    slotProps,
  }: any) => {
    switch (inputType) {
      case 'text': {
        return (
          <FormTextField
            validator={validatorProp}
            error={errorProp}
            name={nameProp}
            viewOnly={viewOnly}
            writeOnly={writeOnly}
            secured={securedProp}
            min={minProp}
            max={maxProp}
            regex={regexProp}
            label={label}
            variant={variantProp}
            step={stepProp}
            table={tableProp}
            squared={squared}
            readOnly={readOnly}
            noColorChange={noColorChange}
            mask={maskProp}
            helperText={helperText}
            maskChar={maskChar}
            width={width}
            maxWidth={maxWidth}
            customStyle={customStyle}
            multiline={multilineProp}
            noPadding={noPadding}
            zeroPadding={zeroPadding}
            rows={rowsProp}
            rowsMax={rowsMaxProp}
            maxLines={maxLinesProp}
            changeCallback={(value) => {
              cbChange(value);
            }}
            onChange={(value) => {
              onChangeProp(value);
            }}
            type={typeProp}
            disabled={disabledProp}
            endProp={endProp}
            required={requiredProp}
            value={valueProp}
            placeholder={placeholderProp}
            size={sizeProp}
          />
        );
      }
      case 'select': {
        return (
          <FormSelect
            options={options}
            disabledOptionValues={disabledOptionValues}
            width={width || '100%'}
            label={label}
            name={nameProp}
            removeIcons={removeIcons}
            lookup={lookup}
            mode={mode}
            squared={squared}
            newLoader={newLoader}
            readOnly={readOnly}
            maxWidth={maxWidth}
            noPadding={noPadding}
            zeroPadding={zeroPadding}
            customStyle={customStyle}
            outcomes={outcomesProp}
            noFlash={noFlash}
            outcomeDetails={outcomeDetailsProp}
            helperText={helperText}
            variant={variantProp}
            value={valueProp}
            changeCallback={({ value, raw }) => {
              cbChange({ value, raw });
            }}
            mapValues={({ value, raw }) => {
              mapValues({ value, raw });
            }}
            optionLabel={optionLabel}
            optionValue={optionValue}
            chipLabel={chipLabel}
            error={errorProp}
            disabled={disabledProp}
            partners={partnersProp}
            required={requiredProp}
            secured={securedProp}
            noColorChange={noColorChange}
            table={tableProp}
            multiple={multipleProp}
            lookupWhere={lookupWhere}
            viewOnly={viewOnly}
            groupBy={groupBy}
            noOptionsDisabled={noOptionsDisabled}
            roles={rolesProp}
            organizations={organizationsProp}
            order={orderProp}
            writeOnly={writeOnly}
            placeholder={placeholderProp}
            size={sizeProp}
            slotProps={slotProps}
            disablePortal={disablePortal}
          />
        );
      }
      case 'checkbox': {
        return (
          <FormCheckbox
            width={width}
            writeOnly={writeOnly}
            viewOnly={viewOnly}
            label={label}
            name={nameProp}
            noPadding={noPadding}
            zeroPadding={zeroPadding}
            noMargin={noMargin}
            readOnly={readOnly}
            noColorChange={noColorChange}
            value={valueProp}
            changeCallback={(value) => {
              cbChange(value);
            }}
            labelPlacement={labelPlacementProp}
            disabled={disabledProp}
          />
        );
      }
      case 'dateTime': {
        return (
          <FormDateTime
            width={width || '100%'}
            label={label}
            type={typeProp || 'dateTime'}
            error={errorProp}
            table={tableProp}
            variant={variantProp}
            noPadding={noPadding}
            zeroPadding={zeroPadding}
            writeOnly={writeOnly}
            noColorChange={noColorChange}
            viewOnly={viewOnly}
            defaultLocal={defaultLocal}
            secured={securedProp}
            name={nameProp}
            readOnly={readOnly}
            maxDate={maxDateProp}
            minDate={minDateProp}
            beforeDeath={beforeDeathProp}
            afterDeath={afterDeathProp}
            maxCustomDate={maxCustomDateProp}
            minCustomDate={minCustomDateProp}
            afterCustomDatetime={afterCustomDatetimeProp}
            beforeCustomDatetime={beforeCustomDatetimeProp}
            pastDisabled={pastDisabled}
            squared={squared}
            required={requiredProp}
            showTimezone={showTimezone}
            setTimezone={setTimezone}
            timezone={timezoneProp}
            value={valueProp}
            disabled={disabledProp}
            changeCallback={({ value }) => {
              cbChange(value);
            }}
            futureDisabled={futureDisabled}
            noInitialValue={noInitialValue}
          />
        );
      }
      default:
        return (
          <div>
            <pre>
              inputType
              {inputType} does not exist
            </pre>
          </div>
        );
    }
  },
);

CustomField.propTypes = {
  optionLabel: PropTypes.string,
  optionValue: PropTypes.string,
  chipLabel: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  afterDeath: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  beforeDeath: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxCustomDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  minCustomDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  afterCustomDatetime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  beforeCustomDatetime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  inputType: PropTypes.string.isRequired,
  width: PropTypes.string,
  readOnly: PropTypes.bool,
  squared: PropTypes.bool,
  removeIcons: PropTypes.bool,
  options: PropTypes.array,
  disabledOptionValues: PropTypes.array,
  name: PropTypes.string,
  lookup: PropTypes.string,
  mode: PropTypes.string,
  maskChar: PropTypes.string,
  mask: PropTypes.string,
  cbChange: PropTypes.func,
  mapValues: PropTypes.func,
  onChange: PropTypes.func,
  endProp: PropTypes.node,
  variant: PropTypes.string,
  required: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  secured: PropTypes.bool,
  type: PropTypes.string,
  step: PropTypes.string,
  timezone: PropTypes.string,
  setTimezone: PropTypes.func,
  showTimezone: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  disabled: PropTypes.bool,
  labelPlacement: PropTypes.string,
  lookupWhere: PropTypes.string,
  groupBy: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.array,
  ]),
  error: PropTypes.string,
  table: PropTypes.bool,
  futureDisabled: PropTypes.bool,
  pastDisabled: PropTypes.bool,
  noOptionsDisabled: PropTypes.bool,
  noColorChange: PropTypes.bool,
  noMargin: PropTypes.bool,
  writeOnly: PropTypes.bool,
  multiple: PropTypes.bool,
  maxWidth: PropTypes.string,
  helperText: PropTypes.string,
  roles: PropTypes.string,
  organizations: PropTypes.string,
  partners: PropTypes.string,
  viewOnly: PropTypes.bool,
  defaultLocal: PropTypes.bool,
  order: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  customStyle: PropTypes.object,
  noInitialValue: PropTypes.bool,
};

CustomField.defaultProps = {
  cbChange: () => {},
  groupBy: () => {},
  mapValues: () => {},
  onChange: () => {},
  setTimezone: () => {},
  maxWidth: '100%',
  customStyle: {},
  variant: 'outlined',
  squared: false,
  showTimezone: false,
  required: false,
  secured: false,
  defaultLocal: false,
  readOnly: false,
  multiline: false,
  removeIcons: false,
  disabled: false,
  writeOnly: false,
  noMargin: false,
  table: false,
  noOptionsDisabled: false,
  multiple: false,
  noColorChange: false,
  viewOnly: false,
  labelPlacement: 'end',
  size: 'small',
  noInitialValue: false,
};

export default CustomField;
